import Helper from './Helper';

class Video {
  constructor() {
    const thumbnail = Array.prototype.slice.call(document.querySelectorAll('.ns-video__thumbnail'));
    thumbnail.forEach(image =>{
      image.addEventListener('click', () => {
        const video = image.parentElement;
        // const button = video.querySelector('button');
        const iframe = video.querySelector('iframe');
        if ( typeof iframe !== undefined && iframe !== null ) {
          iframe.src = iframe.src + '?autoplay=1';
          let card = image.closest('.ns-card');

          if ( typeof card !== undefined && card !== null ) {
            let headline = card.querySelector('.ns-card__headline');
            headline.style.display = 'none';

            let arrow = card.querySelector('.ns-card__arrow');
            arrow.style.display = 'none';
          }
          
          let quoteVideo = image.closest('.ns-video--quote');

          if ( typeof quoteVideo !== undefined && quoteVideo !== null ) {
            let quote = quoteVideo.querySelector('.ns-video__quote');
            quote.style.display = 'none';
          }
        } else {
          const localVideo = video.querySelector('video');
          localVideo.play();
        }
        
        // button.classList.add('fade-out');
        image.classList.add('fade-out');
        // button.style.display = 'none';
        image.style.display = 'none';
      });
    });
  }
} export default Video;
